export default __webpack_public_path__ + "static/media/S_D_True.277d2139.jpg";